export const getters = {
    canStartConversations(state, getters, rootState, rootGetters) {
        return rootGetters['global/account']?.canStartConversations
    },
}
